import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import MuiButton from '@material-ui/core/Button';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';
import NextLink from 'next/link';
import ResultCard from '../../Filter/Card';
import useStores from '../../../utils/useStores';
import useCols from '../../../utils/useCols';
import Wrap from '../../depi/sections/Wrap';

const useStyles = makeStyles(() => ({
  list: {
    overflow: 'visible',
  },
  tile: {
    overflow: 'visible',
  },
  iframe: {
    border: 'none',
  },
}));

const Ticker = () => {
  const classes = useStyles();

  return (
    <Card>
      <CardContent>
        <Box mb={2}>
          <Typography variant="h6" gutterBottom>
            Newsticker
          </Typography>
        </Box>
        <iframe
          src="https://feed.meltwater.com/gyda/outputs/xml/html/18/38/52467.html"
          width="100%"
          height="318"
          scrolling="auto"
          className={classes.iframe}
        />
      </CardContent>
    </Card>
  );
};

const NewsSection = props => {
  const { noTitle, noButton, centeredLabel } = props;
  const { uiStore, dataStore } = useStores();
  const cols = useCols();
  const data = dataStore.pages.latestDepvNews;
  const dataWithTicker = [
    data[0],
    data[1],
    'ticker',
    data[2],
    data[3],
    data[4],
  ].filter(d => !!d);
  const classes = useStyles();
  const linkContext = process.env.NODE_ENV === 'production' ? '/' : '/depv/';

  return (
    <Wrap bgcolor="grey.100">
      {!noTitle && (
        <Box mb={4} textAlign={centeredLabel ? 'center' : 'inherit'}>
          <Typography color="primary" variant="h2">
            News und Presse
          </Typography>
        </Box>
      )}
      {data && (
        <Box mb={8}>
          <GridList
            className={classes.list}
            cellHeight="auto"
            cols={cols}
            spacing={16}
          >
            {dataWithTicker.map(d => {
              if (d === 'ticker')
                return (
                  <GridListTile
                    key="ticker"
                    col={1}
                    classes={{ tile: classes.tile }}
                  >
                    <Ticker />{' '}
                  </GridListTile>
                );
              return (
                <GridListTile
                  classes={{ tile: classes.tile }}
                  key={d.uuid}
                  col={1}
                >
                  <ResultCard data={d} context={uiStore.context} />
                </GridListTile>
              );
            })}
          </GridList>
        </Box>
      )}
      {!noButton && (
        <Box textAlign="center">
          <NextLink
            href={`${linkContext}[...pageId]`}
            as={`${linkContext}news-und-pressemitteilungen`}
            passHref
          >
            <MuiButton target="_blank" size="large" variant="outlined">
              Mehr News und Presse
            </MuiButton>
          </NextLink>
        </Box>
      )}
    </Wrap>
  );
};

NewsSection.defaultProps = {
  label: null,
  button: null,
  centeredLabel: true,
  noButton: false,
  noTitle: false,
};

NewsSection.propTypes = {
  href: PropTypes.string.isRequired,
  centeredLabel: PropTypes.bool,
  noTitle: PropTypes.bool,
  noButton: PropTypes.bool,
};

export default NewsSection;
